import { render, staticRenderFns } from "./BetNumView.vue?vue&type=template&id=79c3cfca&scoped=true"
import script from "./BetNumView.vue?vue&type=script&lang=js"
export * from "./BetNumView.vue?vue&type=script&lang=js"
import style0 from "./BetNumView.vue?vue&type=style&index=0&id=79c3cfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c3cfca",
  null
  
)

export default component.exports